// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606212349/js/" + chunkId + "." + {"44":"84d80a74","225":"a6e12b5e","481":"ed44eb30","486":"9ea683d1","770":"c5b18b23"}[chunkId] + ".0.5497548600740223.chunk.js";
};